let baseApi = '/sp/finish';
// 所有节点，用以动态流程图判断节点位置
let ProcNodesInfo = [
    {
        key: 'start',
        name: '开始',
        disableUserSelect: true
    },
    {
        key: 'tianxieCaigouForm',
        name: '填写表单',
        userKey: 'startUser',
        disableUserSelect: true,
        shenpiBtns: [{ type: 'submit' }]
    },
    {
        key: 'zhuguanShenpiCaigou', // 节点流程定义key
        name: '主管审批', // 节点名
        userKey: 'zhuguanUserCaigou', // 用于显示选择列表
        groupId: '主管,经理', // 相似查询部门为主管经理的用户
        apiSubmit: '/sp/zhuguan-caigou/shenpi', // 审批对应api
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }] // 当前节点审批时，所显示的按钮
    },
    {
        key: 'zongjingbanShenpiCaigou',
        name: '总经办审批',
        userKey: 'zongjingbanUserCaigou',
        groupId: '总经办',
        apiSubmit: '/sp/zongjingban-caigou/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }]
    },
    {
        key: 'huowuQianshou',
        name: '货物签收',
        userKey: 'qianshouUser',
        groupId: '发货部',
        apiSubmit: baseApi,
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass', text: '确认签收' }]
    },
    {
        key: 'tianxieForm',
        name: '填写表单',
        userKey: 'startUser',
        apiSubmit: '/sp/tianxieForm/finish',
        shenpiBtns: [{ type: 'submit' }]
    },
    {
        key: 'caigouQueren',
        name: '采购确认',
        userKey: 'caigouUser',
        groupId: '产品开发',
        apiSubmit: '/sp/caigou/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }]
    },
    {
        key: 'kaifayuanShenpi',
        name: '开发确认',
        userKey: 'kaifayuanUser',
        groupId: '产品开发',
        apiSubmit: '/sp/kaifayuan/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }],
        tip: '该项可不选',
    },
    {
        key: 'fbaYunyingzuzhangShenpi',
        name: '运营组长审核',
        userKey: 'yunyingzuzhangUser',
        groupId: '运营组长',
        apiSubmit: '/sp/yunyingzuzhang/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }],
        desc: 'FBA'
    },
    {
        key: 'yunyingzuzhangShenpi',
        name: '运营组长审核',
        userKey: 'yunyingzuzhangUser',
        groupId: '运营组长',
        apiSubmit: '/sp/yunyingzuzhang/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }],
        desc: '推广申请的运营组长审核'
    },
    {
        key: 'yunyingjingliShenpi',
        name: '运营经理审批',
        userKey: 'yunyingjingliUser',
        groupId: '运营经理',
        apiSubmit: '/sp/yunyingjingli/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }]
    },
    {
        key: 'zhuguanShenpi',
        name: '部门主管审批',
        userKey: 'zhuguanUser',
        groupId: '主管,经理',
        apiSubmit: '/sp/zhuguan/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }]
    },
    {
        key: 'zongcaiShenpi',
        name: '总裁审批',
        userKey: 'zongcaiUser',
        groupId: '总裁',
        apiSubmit: '/sp/zongcai/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }]
    },
    {
        key: 'caiwuShenpi',
        name: '财务复核',
        userKey: 'caiwuUser',
        groupId: '财务',
        apiSubmit: '/sp/caiwu/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }]
    },
    {
        key: 'caiwujingliShenpi',
        name: '财务经理审批',
        userKey: 'caiwujingliUser',
        groupId: '财务经理',
        apiSubmit: '/sp/caiwujingli/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }]
    },
    {
        key: 'gongyinglianZhuguanShenpi',
        name: '供应链主管审批',
        userKey: 'gongyinglianZhuguanUser',
        groupId: '供应链主管',
        apiSubmit: '/sp/gongyinglian-zhuguan/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }]
    },
    {
        key: 'zongjingbanShenpi',
        name: '总经办审批',
        userKey: 'zongjingbanUser',
        groupId: '总经办',
        apiSubmit: '/sp/zongjingban/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }]
    },
    {
        key: 'chunaFukuan',
        name: '出纳付款',
        userKey: 'chunaUser',
        groupId: '出纳',
        apiSubmit: '/sp/chuna/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }]
    },
    {
        key: 'fbaCaigouquerenShenpi',
        name: '采购确认',
        userKey: 'fbaCaigouquerenUser',
        groupId: 'FBA采购确认',
        apiSubmit: '/sp/fba-caigouqueren/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }]
    },
    {
        key: 'huitianyangpindanhao',
        name: '回填样品单号',
        userKey: 'caigouUser',
        groupId: '产品开发',
        apiSubmit: '/sp/yangpindanhao/finish',
        shenpiBtns: [{ type: 'submitOrderNo' }]
    },
    {
        key: 'tuiguangStart',
        name: '开始推广',
        userKey: 'startUser',
        apiSubmit: baseApi,
        shenpiBtns: [{ type: 'pass', text: '完成' }]
    },
    {
        key: 'serverBuy',
        name: '服务器购买',
        userKey: 'serverUser',
        groupId: '服务器管理',
        apiSubmit: baseApi,
        shenpiBtns: [{ type: 'pass', text: '购买完成' }]
    },
    {
        key: 'serverXufei',
        name: '服务器续费',
        userKey: 'serverUser',
        groupId: '服务器管理',
        apiSubmit: baseApi,
        shenpiBtns: [{ type: 'pass', text: '续费完成' }]
        /*{
            key: 'inform',
            name: '通知总经办',
            userKey: 'qianshouUser'
        },*/
    },
    {
        key: 'renshiShenpi',
        name: '人事审批',
        userKey: 'renshiUser',
        groupId: '人力资源部',
        apiSubmit: '/sp/renshi/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }]
    },
    {
        key: 'lingdaoShenpi',
        name: '领导审批',
        userKey: 'lingdaoUser',
        groupId: '主管,经理',
        apiSubmit: '/sp/lingdao/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }]
    },
    {
        key: 'zhuguanQueren',
        name: '部门主管确认',
        userKey: 'zhuguanUser',
        groupId: '主管',
        apiSubmit: '/sp/zhuguan-queren/shenpi',
        shenpiBtns: [{ type: 'unPass' }, { type: 'pass' }],
        desc: '仅产品部门的申请需要再次最终确认'
    },
    {
        key: 'end',
        name: '结束',
        disableUserSelect: true
    }];
let map = {}
ProcNodesInfo.forEach(node => map[node.key] = node)

export default {
    'all': ProcNodesInfo,
    'keys': Array.from(ProcNodesInfo, node => node.key),
    'names': Array.from(ProcNodesInfo, node => node.name),
    'map': map,
    /*
    * find('key', 'start')
    * @return object
    * */
    find(anyKey, val) {
        return ProcNodesInfo.find(item => {
            // eslint-disable-next-line no-prototype-builtins
            let hasKey = item.hasOwnProperty(anyKey);
            return hasKey && item[anyKey] === val;
        })
    }
}
